var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificate-access-loading d-flex align-items-center justify-content-center min-vh-100"},[_c('p',{staticClass:"mb-0"},[_vm._v("Opening certificate…")])])
}]

export { render, staticRenderFns }